<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 md6
      v-for="(data, index) in my_data" :key="index"
      >
        <v-text-field
         color="green"
         v-model="data.value" 
         :label="data.label" 
         readonly
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-combobox
          v-model="my_skills.tech_skills"
          items=""
          label="Tech Skills"
          multiple
          chips
          readonly
          color="green"
        ></v-combobox>
      </v-flex>
      <v-flex xs12>
        <v-combobox
          v-model="my_skills.other_skills"
          items=""
          label="Other Skills"
          multiple
          chips
          readonly
          color="greend"
        ></v-combobox>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
data: () => ({
  my_skills: {
    'tech_skills': [
      'Python/Django/Flask',
      'Php/Laravel',
      'R', 'Golang', 'Git',
      'Docker', 'Kubernettes'
    ],
    'other_skills': [
      'Team Management', 'Scrum Methodology', 'Fast Learner',
      'Fluent English communication'
    ] 
  },
  my_data: [
    {
      label: "Full Name",
      value: "AMEH SAMUEL OJONIDE"
    },
    {
      label: "Contact Num",
      value: "+2347055078897"
    },
    {
      label: "Email",
      value: "propersam2012@gmail.com"
    },
    {
      label: "Nationality",
      value: "Nigerian"
    }
  ]
  
}),

}
</script>


